import { render } from "./DetailsForm.vue?vue&type=template&id=5e4358fd"
import script from "./DetailsForm.vue?vue&type=script&lang=js"
export * from "./DetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__